@if (activeGame) {
  <h3 data-testid="active-game-name">{{ activeGame.Name }} - Charity Payouts</h3>

  <c-row class="mb-3">
    <c-col md="3" class="mb-3">
      <div cListGroup>
        <button cListGroupItem
                data-testid="balances-summary-tab"
                (click)="currentScreenState = ScreenState.BalancesSummary"
                [active]="currentScreenState === ScreenState.BalancesSummary">
          <div>
            <h5 class="mb-1">Charity Balances Summary</h5>
            <p>View balances for all charities in this game</p>
          </div>
        </button>

        <button cListGroupItem
                data-testid="view-payouts-tab"
                (click)="currentScreenState = ScreenState.ViewPayouts"
                [active]="currentScreenState === ScreenState.ViewPayouts">
          <div>
            <h5 class="mb-1">View Charity Payouts</h5>
            <p>View all payouts for charities in this game</p>
          </div>
        </button>

        <button cListGroupItem
                data-testid="add-payout-tab"
                *hasPermission="permissionTypes.ModifyCharityPayouts"
                (click)="navigateToAddPayout()"
                [active]="currentScreenState === ScreenState.AddPayout">
          <div>
            <h5 class="mb-1">Add Charity Payout</h5>
            <p>Create a new charity payout for this game</p>
          </div>
        </button>
        <button cListGroupItem
                data-testid="adjustments-tab"
                *hasPermission="permissionTypes.ViewCharityAdjustments"
                (click)="currentScreenState = ScreenState.Adjustments"
                [active]="currentScreenState === ScreenState.Adjustments">
          <div>
            <h5 class="mb-1">Adjustments &amp; Chargebacks</h5>
            <p>Change what a charity is owed without a payment</p>
          </div>
        </button>
        <button cListGroupItem
                data-testid="payees-tab"
                (click)="currentScreenState = ScreenState.Payees"
                [active]="currentScreenState === ScreenState.Payees">
          <div>
            <h5 class="mb-1">Central Payees</h5>
            <p>Charities paid through one account, and payments to it</p>
          </div>
        </button>
      </div>
    </c-col>

    <c-col>
      @switch (currentScreenState) {
        @case (ScreenState.BalancesSummary) {
          <app-charity-balances-summary
            [gameData]="activeGame"
            (makePayoutClick)="onMakePayoutClick($event)">
          </app-charity-balances-summary>
        }
        @case (ScreenState.ViewPayouts) {
          <app-view-charity-payouts [gameData]="activeGame"></app-view-charity-payouts>
        }
        @case (ScreenState.Adjustments) {
          <app-charity-adjustments [gameData]="activeGame"></app-charity-adjustments>
        }
        @case (ScreenState.Payees) {
          <app-charity-payees [gameData]="activeGame"></app-charity-payees>
        }
        @case (ScreenState.AddPayout) {
          <app-add-charity-payouts
            [gameData]="activeGame"
            [preselectedCharity]="selectedCharity"
            (payoutCreated)="onPayoutCreated()">
          </app-add-charity-payouts>
        }
      }
    </c-col>
  </c-row>
}
